import * as React from 'react';
import { useState } from 'react';

import './style.scss';

const AchievementCard = props => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleClick = e => {
    if (typeof window !== `undefined` && window.innerWidth > 1024) {
      e.preventDefault();
    }

    setIsFlipped(!isFlipped);
  };

  return (
    <div data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
      <div
        className="achievement-card-anchor" 
        // id={`achievement_${props.id}`} 
        />
      <a
        role="button"
        // href={`#achievement_${props.id}`}
        className={`achievement-card ${isFlipped ? 'is-flipped' : ''}`}
        tabIndex={0}
        onClick={handleClick}
      >
        <div className="card-inner">
          <div className="front">
            <div className="subtitle">{props.subtitle}</div>
            <h3 className="front-title">{props.title}</h3>
            <div className="flip-toggle">View Achievements</div>
          </div>

          <div className="back">
            <h4 className="back-title">Achievements</h4>
            <ul>
              {props.achievements.map((achievement, i) => (
                <li key={i}>{achievement}</li>
              ))}
            </ul>
            <div className="flip-toggle">Close</div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default AchievementCard;
